<template>
  <!-- <=SM: d-block d-sm-none -->
  <!--  >SM: d-none d-sm-block -->
  <div>
    <sub class="text-secondary">{{ $t('global.onDate') }}&nbsp;</sub>
    <span>{{ $d(new Date(props.at), 'dateonly') }}&nbsp;</span>
    <br class="d-block d-md-none">
    <sub class="text-secondary">{{ $t('global.atTime') }}&nbsp;</sub>
    <span>{{ $d(new Date(props.at), 'timeonly') }}&nbsp;</span>
    <span v-if="user" class="d-none d-xl-inline">
      <sub class="text-secondary">{{ $t('global.by') }}</sub>
      {{ user.name ?? user.email }}
    </span>
    <span v-else class="d-none d-xl-inline">
      <sub class="text-secondary">{{ $t('global.by') }}</sub>
      {{ $t('global.anonymousUser') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useUsersStore } from '@/stores';
import { computed } from 'vue';

const usersStore = useUsersStore();

const props = defineProps({
  at: { type: String, required: true },
  by: { type: Number, required: true },
});

const user = computed(() => {
  return usersStore.getUserById(props.by);
});
</script>
